import React from 'react'
import { cn } from '@utils/safeTs'
import styles from './MyAccountDashboardBox.module.sass'
import useTrans from '@hooks/useTrans'
import { Loading } from '@components/atoms'


interface Props {
  title?: string
  icon?: React.ReactNode
  badgeValue?: number
  loading?: boolean
  variant?: 'alert' | 'notifiche' | 'default'
  children?: React.ReactNode
  className?: string
}

const MyAccountDashboardBox = (props: Props) => {

  const { 
    title,
    icon,
    badgeValue,
    loading = false,
    variant = 'default',
    children,
    className = '',
  } = props

  const t = useTrans()

  return (
    <section
      className={cn(styles.root, styles[`root--${variant}`], className)}
      aria-label={title}
    >
      <header className={styles.header}>
        <span className={styles.icon} aria-hidden>
          {icon}
        </span>
        <span className={styles.title}>{title}</span>
        {typeof badgeValue === 'number' && !loading ? (
          <span className={styles.badge} aria-label={t('{0} nuovi elementi', [badgeValue])}>
            {badgeValue}
          </span>
        ) : null}
      </header>
      {loading ? <div className={styles.loaderBox}><Loading width={60} height={60} /></div> : children}
    </section>
  )
}

export default MyAccountDashboardBox
